/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

function readTrackingData($el) {
	var data = {conversion: undefined, cart: undefined};

	var conversion = {
		category: $el.data('conversion-category'),
		detail: $el.data('conversion-detail'),
		'class': $el.data('conversion-class') || '',
	};

	if(conversion.category && conversion.detail) {
		data.conversion = conversion;
	}

	var ordercase = $el.data('tracking-ordercase');
	if(ordercase) {
		data.cart = {ordercase: ordercase};
	}

	return data;
}

/**
 * MultipageWizard Skin implementation for the ScForm module.
 *
 * @author Zeljko Curcic, Thomas Junghans
 * @namespace Tc.Module.ScForm
 * @class MultipageWizard
 * @extends Tc.Module
 * @constructor
 */
Tc.Module.ScForm.MultipageWizard = function (parent) {
	/* jshint maxstatements: false */

	/**
	 * @type {string}
	 */
	this.STEP_PREFIX = 'multipageStep-';

	/**
	 * @type {string}
	 */
	this.EVT_STEP_LOADED = 'steploaded';

	/**
	 * @type {string}
	 */
	this.EVT_BEFORE_ACTION = 'beforeaction';

	/**
	 * @type {string}
	 */
	this.EVT_BEFORE_NEXT_STEP = 'beforenextstep';

	/**
	 * @type {string}
	 */
	this.EVT_BEFORE_PREVIOUS_STEP = 'beforepreviousstep';

	/**
	 * Event fired after the step is changed
	 * @type {string}
	 */
	this.EVT_STEP_CHANGE = 'stepchange';

	/**
	 * Page template name used by Help Widget pages
	 */
	this.TEMPLATE_TYPE_HELP_WIDGET = 'Portal Contact-Widget Page';

	/**
	 * Required for page ajax request
	 * @type {string}
	 */
	this.STEP_LINK_SUFFIX = '/_jcr_content/parsys/form/formpar.html';

	// developmental feature: add mobile selector in preview mode on author
	if (window.location.href.indexOf('wcmmode=disabled') > 0) {
		if (location.href.match(/\.mobile\.html/)) {
			this.STEP_LINK_SUFFIX = this.STEP_LINK_SUFFIX.replace('.html', '.mobile.html');
		}
	}

	this.HASH_PREFIX = 'ms-';

	/**
	 * The pages get appended to this container
	 * @type {jQuery|null}
	 */
	this.$stepContainer = null;

	this.clsHidden = 'hidden';

	this.lastTrackedStep = '';
	this.trackingData = {};

	/**
	 * This is fired just before the next step is loaded or displayed. This is when you want to validate.
	 * @event steploaded
	 * @param nextStepUrl
	 * @param nextStepId
	 * @param currentStepId
	 */
	this.fireBeforeNextStep = function (nextStepUrl, nextStepId, currentStepId) {
		this.$ctx.trigger(this.EVT_BEFORE_NEXT_STEP, [nextStepUrl, nextStepId, currentStepId]);
	};

	this.fireBeforePreviousStep = function (prevStepId) {
		this.$ctx.trigger(this.EVT_BEFORE_PREVIOUS_STEP, [prevStepId]);
	};

	this.fireBeforeAction = function (nextStepUrl, nextStepId, currentStepId, dataWarehouseTrackingEnabled) {
		this.$ctx.trigger(this.EVT_BEFORE_ACTION, [nextStepUrl, nextStepId, currentStepId, dataWarehouseTrackingEnabled]);
	};

	this.fireStepChange = function () {
		this.$ctx.trigger(this.EVT_STEP_CHANGE);
	};

	/**
	 * Fired after step is loaded and displayed. This is when new form fields need to be initialized
	 * @param stepUrl
	 * @param stepId
	 */
	this.fireStepLoaded = function (stepUrl, stepId) {
		this.$ctx.trigger(this.EVT_STEP_LOADED, [stepUrl, stepId]);
	};

	/**
	 * Wrapper for user.getFullName()
	 * @returns {string}
	 */
	this.getUserFullName = function () {
		if(this.user) {
			return this.user.getFullName();
		}
		return '';
	};

	/**
	 * Wrapper for user.getFirstName()
	 * @returns {string}
	 */
	this.getUserFirstName = function () {
		if(this.user) {
			return this.user.getFirstName();
		}
		return '';
	};

	/**
	 * Wrapper for user.getLastName()
	 * @returns {string}
	 */
	this.getUserLastName = function () {
		if(this.user) {
			return this.user.getLastName();
		}
		return '';
	};

	this.goToNextStep = function (nextStepUrl, nextStepId, currentStepId) {
		var mod = this;

		if (document.getElementById(nextStepId) !== null) {
			mod.showStep(nextStepId);
		} else {
			mod.loadStep(nextStepUrl, currentStepId);
		}

	};

	this.handleError = function (data) {
		var mod = this,
			showDefaultMsgBox = true;

		mod.disableFormSubmissions = false;

		//handle response object
		if (data.status && data.responseText) {
			try {
				data = $.parseJSON(data.responseText);
			}
			catch (e) {
				this.showAjaxError(data.status);
				return;
			}
		}

		if (data.data && $.isArray(data.data) && data.data.length > 0) {
			mod.$ctx.find('.modCaptcha').trigger('reloadCaptcha');
			var showValidationMsg = true,
				ok;
			$.each(data.data, function (index, invalidField) {
				ok = mod.markFieldAsInvalid(invalidField);
				showValidationMsg = showValidationMsg && !ok ? false : true;
			});

			if (!showValidationMsg) {
				//reset message
				data.message = '';
			}

			showDefaultMsgBox = false;
		}

		if (data.message && data.message.length > 0) {
			var elContainer = mod.$ctx.find('div.headingError.client-side');
			var el = elContainer.find('.msg');
			el.text(data.message);
			elContainer.removeClass('hidden');
			showDefaultMsgBox = false;
		}

		//show default msg box
		if (showDefaultMsgBox) {
			this.showAjaxError();
		}
	};

	this.resetServersideInvalidFields = function () {
		var mod = this;
		$('div.error', mod.$ctx).removeClass('error');
		$('.error-field', mod.$ctx).removeClass('error-field');
		$('span.error', mod.$ctx).addClass('hidden').text('');
		$('div.headingError', mod.$ctx).addClass('hidden');
	};

	this.showAjaxError = function (errorCode) {
		var mod = this,
			errorTitle = errorCode === 403 ? mod.error403Title : mod.errorTitle,
			errorMessage = errorCode === 403 ? mod.error403Message : mod.errorMessage;

		mod.formApi.renderPopupMessage(errorMessage, errorTitle);
	};

	this.onAjaxError = function (data) {
		this.errorTitle = data.title;
		this.errorMessage = data.message;
		this.showAjaxError();
	};

	this.onHandleError = function (data) {
		this.resetServersideInvalidFields();
		this.handleError(data);
	};

	this.executeAction = function (nextStepUrl, nextStepId, currentStepId, promise) {
		var mod = this,
			frm = $('form.wizard');
		promise = promise || $.Deferred().resolve();
		promise.then(function () {
			$.ajax({
				type: frm.attr('method'),
				url: frm.attr('action'),
				dataType: 'json',
				data: frm.serialize().replace(new RegExp('\'', 'g'), '%27').replace(/\(/g, '%28').replace(/\)/g, '%29'),
				success: function (data) {
					mod.resetServersideInvalidFields();
					if (data.success === 'true' || data.success === true) {
						if (data.href) {
							if (data.target) {
								window.open(data.href, data.target);
							} else {
								window.open(data.href);
							}
						}
						if (nextStepUrl && nextStepUrl.length > 0) {
							mod.goToNextStep(nextStepUrl, nextStepId, currentStepId);
						}
					} else {
						mod.handleError(data);
					}
				},
				error: function (jqXHR) {
					mod.resetServersideInvalidFields();
					mod.handleError(jqXHR);
				}
			});
		});
	};

	this.dataWarehouseTracking = function () {
		var mod = this,
			location = window.utag_data && window.utag_data.page_template && window.utag_data.page_template !== mod.TEMPLATE_TYPE_HELP_WIDGET
				? "Content"
				: "Help-Widget",
			interaction = new SCS.portal.datalayer.Interaction()
				.withEvent('submit', '', location, 'multistepform');

		interaction.event.rawdata = {};

		mod.log('datawarehouse tracking enabled');
		mod.$ctx.find('[data-sdw-mapping]').each(function () {

			// skip unselected radio buttons and checkboxes
			if (($(this).is('input:radio') || $(this).is('input:checkbox')) && !$(this).is(':checked')) {
				return true;
			}
			interaction.event.rawdata[$(this).data('sdw-mapping')] = $(this).val();
			mod.log($(this).data('sdw-mapping'), ' > ', $(this).val());
		});
		interaction.track();
	};

	/**
	 * Marks the invalid fields with a css class
	 *
	 * @method markFieldAsInvalid
	 * @param invalidField
	 * @returns {Tc.Module.ScForm}
	 */
	this.markFieldAsInvalid = function (invalidField) {
		var mod = this,
			$field = mod.$ctx.find('#' + invalidField.id),
			$fieldContainer = $field.closest('.field'),
			$errorField = $fieldContainer.find('span.error'),
			$msgDiv = $fieldContainer.find('div.sdx.message');

		$fieldContainer.addClass('error');
		$errorField.html($errorField.html() + ($errorField.html() === '' ? '' : '<br/>') + '<div>' + invalidField.messages + '</div>');
		$errorField.removeClass('hidden');
		if($msgDiv){
			$msgDiv.removeClass('hidden');
		}
		$field.addClass('error-field');
		return $field || $field.length > 0;
	};

	/**
	 * Wrapper for profile.getUser() !== null
	 * Returns true if the user is logged in, false if anonymous or login state is unknown
	 * @returns {boolean}
	 */
	this.isUserLoggedIn = function () {
		return !!this.user;
	};

	/**
	 * Expects "url" to be a string such as
	 * /de/component-gallery/swisscom/components/wimbledon-sme/business-internetstandardform/installation
	 *
	 * In case of the above string, the return would be "multipageStep-installation"
	 *
	 * @method makeStepId
	 * @param url {string}
	 * @returns {string}
	 */
	this.makeStepId = function (url) {
		if (url && url.length > 0) {
			var res = url.match(/\/([^\/?#]+)(\?|#|$)/);
			return this.STEP_PREFIX + (res.length > 1 ? res[1] : 'empty');
		}

		return this.STEP_PREFIX + 'empty';
	};

	/**
	 * Expects the path of the page to be loaded and uses the part after the last "/"
	 *
	 * @method makeTrackingStepName
	 * @param stepUrl {string}
	 * @returns {string}
	 */
	this.makeTrackingStepName = function (stepUrl) {
		return stepUrl.substring(stepUrl.lastIndexOf('/') + 1, stepUrl.length);
	};

	/**
	 * Executed when the "back" button is clicked
	 *
	 * @method multiPageBackwardHandler
	 * @param event
	 */
	this.multiPageBackwardHandler = function (event) {
		event.preventDefault();

		var mod = this,
			$el = $(event.currentTarget),
			prevStepId = $el.parents('.multipage-wizard-step').data('prev');

		mod.fireBeforePreviousStep(prevStepId);

		mod.trackingData = readTrackingData($el);

		mod.showStep(prevStepId);

		mod.fireStepChange();
	};

	/**
	 * Executed when the "next" button is clicked
	 *
	 * @method multiPageForwardHandler
	 * @param event
	 */
	this.multiPageForwardHandler = function (event) {
		event.preventDefault();

		var mod = this,
			$el = $(event.currentTarget),
			$currentStep = $el.closest('.multipage-wizard-step'),
			currentStepId = $currentStep.prop('id'),
			nextStepUrl = $el.attr('href'),
			nextStepId = mod.makeStepId(nextStepUrl);

		if ($el.hasClass('disabled')) {
			return;
		}

		mod.trackingData = readTrackingData($el);

		// Validation of current step and loading of next are done in the event handler
		mod.fireBeforeNextStep(nextStepUrl, nextStepId, currentStepId);
	};

	this.onStepChange = function (data) {
		if (data.step === 'next') {
			this.multiPageForwardHandler(data.event);
		} else if (data.step === 'previous') {
			this.multiPageBackwardHandler(data.event);
		}
	};

	this.multiPageActionHandler = function (e) {
		e.preventDefault();
		var mod = this,
			$el = $(e.currentTarget),
			$currentStep = $el.closest('.multipage-wizard-step'),
			currentStepId = $currentStep.prop('id'),
			nextStepUrl = $el.attr('href'),
			nextStepId = mod.makeStepId(nextStepUrl),
			dataWarehouseTrackingEnabled = $el.data('datawarehouse-tracking-enabled') || false;

		mod.trackingData = readTrackingData($el);

		// Validation of current step and loading of next are done in the event handler
		mod.fireBeforeAction(nextStepUrl, nextStepId, currentStepId, dataWarehouseTrackingEnabled);
	};

	this.on = function (callback) {
		var mod = this,
			$ctx = mod.$ctx,
			startpageUrl = $ctx.data('startpage');

		require('lib/personalization/profile').getProfile().then(function(profile) {
			mod.user = profile.getUser();
		});

		// Run parent first before anything else!
		parent.on(callback);

		mod.formApi = parent.$ctx.data('form-api');
		mod.$stepContainer = mod.$ctx.find('form');

		mod.$stageMobile = $ctx.closest('div.stageMobile');
		mod.errorTitle = mod.$ctx.data('error-title');
		mod.errorMessage = mod.$ctx.data('error-msg');
		mod.error403Title = mod.$ctx.data('error-403-title');
		mod.error403Message = mod.$ctx.data('error-403-msg');

		mod.disableFormSubmissions = false;

		$ctx.on(mod.EVT_STEP_LOADED, function () {

			// 1. Reinit form
			mod.formApi.reInit();

			if (mod.formApi.getReferrerButton() && !mod.referrerButtonMoved) {
				mod.referrerButtonMoved = true;
				var button = mod.formApi.getReferrerButton().clone();
				mod.formApi.getReferrerButton().remove();
				$('.buttonGroup .clear', mod.$ctx).before($('<div/>').addClass('back').append(button));
			}

			// 2. Get user login and check for fields
			if (mod.isUserLoggedIn()) {

				// The following three input fields are pre-filled if a user is logged in.
				// The pre-filling only happens once in case the user changes the values
				var $inputName = $ctx.find('input[name="name"]'),
					$inputFirstName = $ctx.find('input[name="firstname"]'),
					$inputLastName = $ctx.find('input[name="lastname"]');

				if ($inputName.length === 1 && typeof($inputName.data('prefilled')) === 'undefined') {
					$inputName.val(mod.getUserFullName());
					$inputName.data('prefilled', true);
				}

				if ($inputFirstName.length === 1 && typeof($inputFirstName.data('prefilled')) === 'undefined') {
					$inputFirstName.val(mod.getUserFirstName());
					$inputFirstName.data('prefilled', true);
				}

				if ($inputLastName.length === 1 && typeof($inputLastName.data('prefilled')) === 'undefined') {
					$inputLastName.val(mod.getUserLastName());
					$inputLastName.data('prefilled', true);
				}

			}

			if (SCS.utils.isMobilePage()) {
				// Add additional form padding
				mod.addFormStepTopPadding();
			}
		});

		$ctx.on(mod.EVT_BEFORE_NEXT_STEP, function (e, nextStepUrl, nextStepId, currentStepId) {

			// A validation context needs to be provided to validate only the current step
			mod.formApi.setValidationContext($(document.getElementById(currentStepId))); // The context is automatically reset after validation

			var numberOfInvalidElements = mod.formApi.validateForm('advanceStep');

			mod.log('There are', numberOfInvalidElements, 'invalid elements', mod.disableFormSubmissions);

			if (numberOfInvalidElements === 0 && !mod.disableFormSubmissions) {
				mod.disableFormSubmissions = true;
				mod.goToNextStep(nextStepUrl, nextStepId, currentStepId);
				mod.fireStepChange();
			}
		});

		/**
		 * Fired before the submit action
		 */
		$ctx.on(mod.EVT_BEFORE_ACTION, function (e, nextStepUrl, nextStepId, currentStepId, dataWarehouseTrackingEnabled) {

			var numberOfInvalidElements = mod.formApi.validateForm('stepAction');

			// A validation context needs to be provided to validate only the current step
			mod.formApi.setValidationContext($(document.getElementById(currentStepId))); // The context is automatically reset after validation
			mod.log('There are', numberOfInvalidElements, 'invalid elements', mod.disableFormSubmissions);

			if (numberOfInvalidElements === 0 && !mod.disableFormSubmissions) {

				var promise = $.Deferred().resolve();

				var tvProductId = mod.$ctx.find('#tv_uhd').val();
				if (tvProductId && tvProductId.length) {
					promise = mod.processPayment(tvProductId);
				}

				if (dataWarehouseTrackingEnabled) {
					mod.dataWarehouseTracking();
				}

				mod.disableFormSubmissions = true;
				if (tvProductId && tvProductId.length) {
					mod.executeAction('', nextStepId, currentStepId, promise);
					mod.disableFormSubmissions = false;
				} else {
					mod.executeAction(nextStepUrl, nextStepId, currentStepId, promise);
				}

			}
		});

		$ctx.on(mod.EVT_STEP_CHANGE, function () {
			window.scrollTo(0, 0);
		});

		mod.formApi.executeSpecialButtonHandlers(false);
		$ctx.on('click', '.multipage-forward-button', $.proxy(mod.multiPageForwardHandler, mod));
		$ctx.on('click', '.multipage-back-button', $.proxy(mod.multiPageBackwardHandler, mod));
		$ctx.on('click', '.multipage-action-button', $.proxy(mod.multiPageActionHandler, mod));

		$(window).on('hashchange', function () {
			var prevStepId = mod.getStepHash();

			mod.showStep(prevStepId);
		});


		$ctx.on('keyup keydown keypress', 'input', function (event) {
			if (event.which === 13) {
				event.stopImmediatePropagation();
				event.preventDefault();
				if (!mod.advanceStep()) {
					mod.stepAction();
				}
				return false;
			}
		});

		$ctx.data('api').advanceStep = $.proxy(mod, 'advanceStep');
		$ctx.data('api').stepAction = $.proxy(mod, 'stepAction');

		mod.loadStep(startpageUrl);
	};

	/**
	 * TODO: Add Description
	 * @param data
	 */
	this.onPreloadNextStep = function (data) {
		var mod = this;
		mod.loadStep(data.stepUrl, data.prevStep, true);
	};

	this.onPreloadNextStepAndDisplay = function (data) {
		var mod = this;
		mod.loadStep(data.stepUrl, data.prevStep, false);
	};

	this.getUrlParameters = function () {
		var startIndex = window.location.href.indexOf('?'),
			endIndex = window.location.href.indexOf('#');
		if (startIndex > 0) {
			if (endIndex > 0 && endIndex > startIndex) {
				return window.location.href.substring(startIndex, endIndex);
			} else {
				return window.location.href.substring(startIndex);
			}
		}
		return '';
	};

	/**
	 * Trigger step change tracking
	 */
	this.trackStep = function (stepId) {
		var mod = this,
			// remove prefix and query parameters
			originalTrackingName = stepId.substr(mod.STEP_PREFIX.length).split("?")[0].split("#")[0],
			trackingName = originalTrackingName;

		// update metalyzer conversion value for the current step
		if (window.metalyzerTrackerList && originalTrackingName in metalyzerTrackerList && metalyzerTrackerList[originalTrackingName] !== "") {
			SCS.portal.datalayer.addUdoProperty("metalyzer_conv_tracker", metalyzerTrackerList[originalTrackingName]);
		}

		// update mxcIntelliAdTrackerId for the current step
		if (window.mxcIntelliAdTrackerList && originalTrackingName in mxcIntelliAdTrackerList && mxcIntelliAdTrackerList[originalTrackingName] !== "") {
			SCS.portal.datalayer.addUdoProperty("mxc_ia_tracker", mxcIntelliAdTrackerList[originalTrackingName]);
		}

		// update mxcDcIntelliAdTrackerId for the current step
		if (window.mxcDcIntelliAdTrackerList && originalTrackingName in mxcDcIntelliAdTrackerList && mxcDcIntelliAdTrackerList[originalTrackingName] !== "") {
			SCS.portal.datalayer.addUdoProperty("mxc_dc_tracker", mxcDcIntelliAdTrackerList[originalTrackingName]);
		}

		// update productId for the current step
		if (window.productMap && originalTrackingName in productMap && productMap[originalTrackingName] !== "") {
			SCS.portal.datalayer.setProduct(productMap[originalTrackingName]["id"], productMap[originalTrackingName]["key"], productMap[originalTrackingName]["name"]);
		}

		// update page type for the current step
		if (window.trackingPageTypeMap && originalTrackingName in trackingPageTypeMap && trackingPageTypeMap[originalTrackingName] !== "") {
			SCS.portal.datalayer.setPageType(trackingPageTypeMap[originalTrackingName]);
		}

		// page view tracking, afterwards revert alias to actual page name for language independent tracking
		if (window.aliasList && trackingName in aliasList) {
			trackingName = aliasList[trackingName];
		}
		if (SCS.portal.datalayer && trackingName !== mod.lastTrackedStep) {
			if (SCS.portal.datalayer.pushPagePath(trackingName, true)) {
				mod.log("trackStep > trackingName: ", trackingName);

				// add conversion information in tracking object
				mod.log("trackStep > form submit with tracking data:", mod.trackingData);
				Object.assign(SCS.portal.datalayer.trackObj, mod.trackingData);

				SCS.portal.datalayer.trackPageView();

				// reset conversion info
				mod.trackingData = {};
			}
			mod.lastTrackedStep = trackingName;
		}
	};

	/**
	 * Loads the step using ajax and shows it once loaded, if preLoad is false or not given that is.
	 *
	 * @param stepUrl
	 * @param prevStep
	 * @param preLoad {boolean}, optional
	 */
	this.loadStep = function (stepUrl, prevStep, preLoad) {

		var mod = this,
			stepId = mod.makeStepId(stepUrl),
			$wrapper = $('<div class="multipage-wizard-step hidden"></div>').attr({'id': stepId, 'data-prev': prevStep});

		// make sure we don't create steps that already exists (for multiple events fired in ie8)
		if (mod.$ctx.find('#' + stepId).length) {
			mod.log('Attempted creation of multiple form steps with the same id');
			return;
		}

		// Trigger Create for Jquery Mobile, pages via Ajax are otherwise not covered by jquery mobile
		$wrapper.appendTo(mod.$stepContainer);

		if (mod.getIndexOfStepById(stepId) === 0) {
			$wrapper.addClass('first');
		}

		if (!preLoad) {
			mod.toggleLoadingIndicator(true);
		}

		if (stepUrl) {
			stepUrl = stepUrl.replace(/(\?|#).*/, "");
		}

		$wrapper.load(stepUrl + mod.STEP_LINK_SUFFIX + mod.getUrlParameters(), function () {
			if (!preLoad) {
				mod.toggleLoadingIndicator(false);
				mod.showStep(stepId);
			}
			SCS.utils.initNewModules(mod.$stepContainer);

			mod.fireStepLoaded(stepUrl, stepId);
		});
	};

	this.toggleLoadingIndicator = function (toggle) {
		var mod = this,
			$loadingIndicator = mod.$ctx.find('.loader-wrap'),
			$steps = $('div.multipage-wizard-step', mod.$ctx);

		if (toggle) {
			$steps.addClass(mod.clsHidden);
			$loadingIndicator.removeClass(mod.clsHidden);
		} else {
			$loadingIndicator.addClass(mod.clsHidden);
		}
	};

	/**
	 * showStep and loadStep are not the same thing
	 *
	 * Shows a step that has already been loaded into the dom
	 *
	 * @method showStep
	 * @param stepId
	 */
	this.showStep = function (stepId) {
		this.disableFormSubmissions = false;

		var mod = this,
			$step,
			$steps = $('div.multipage-wizard-step', mod.$ctx),
			stepIndex;

		if (SCS.utils.isMobilePage()) {
			$steps.trigger('create');
		}

		mod.fire('BeforeShowStep', {'stepId': stepId}, ['wizard']);

		mod.updateSummary(stepId);
		mod.formApi.updateSummaries();

		$steps.addClass(mod.clsHidden);
		$step = $(document.getElementById(stepId));
		$step.removeClass(mod.clsHidden);

		if (!SCS.utils.isMobilePage()) {
			mod.recalculateDropdownWidths($step);
		}

		stepIndex = mod.getIndexOfStepById(stepId);

		if (stepIndex !== -1) {
			mod.fire('stepChange', {stepIndex: stepIndex});

			// Only update hash if the step id and hash differ, otherwise showStep is called too often
			if (mod.getStepHash() !== stepId) {
				mod.setStepHash(stepId);
			}

			// Adding class to non module
			mod.$stageMobile.toggleClass('navigation-back', $step.find('.scs-form-navigation').length > 0);
		} else {
			window.history.go(-1);
		}
		mod.trackStep(stepId);
	};

	/**
	 * stepId is the value of the id-attribute in
	 * <div class="multipage-wizard-step" id="multipageStep-konfiguration">
	 *
	 * @method getIndexOfStepById
	 * @param stepId {string}
	 */
	this.getIndexOfStepById = function (stepId) {
		var mod = this,
			$steps = $('div.multipage-wizard-step', mod.$ctx),
			$step = $(document.getElementById(stepId));

		return $steps.index($step);
	};

	/**
	 * Converts the hash from the url to the step html id attribute.
	 *
	 * if the id value is "multipageStep-konfiguration" then the location.hash will be ms-multipageStep-konfiguration
	 *
	 * location.hash = 'ms-'
	 */
	this.getStepHash = function () {
		var mod = this;

		return location.hash.split('#' + mod.HASH_PREFIX)[1];
	};

	/**
	 *
	 * @method setStepHash
	 * @param newHash
	 */
	this.setStepHash = function (newHash) {
		var mod = this;

		location.hash = mod.HASH_PREFIX + newHash;
	};

	/**
	 * This function updates form summary pages after.
	 * TODO(ces): rename this function to be more generic
	 *
	 * Summary pages must use following naming convention to fetch data from other form steps:
	 *
	 * Display text set in form element with name 'company'
	 * <span data-bind="text: company"></span>
	 *
	 * Show text "Show" only, if form element with name 'advice' has value 'sms'
	 * <span data-bind="conditional: advice: sms">Show</span>
	 *
	 * @method updateSummary
	 * @param {String} stepId only summary fields of the given step get updated
	 * @return void
	 */
	this.updateSummary = function (stepId) {
		var mod = this,
			$ctx = mod.$ctx;

		$(document.getElementById(stepId)).find('[data-bind]').each(function () {
			var $this = $(this),
				bindings = $(this).attr('data-bind').split(':'),
				type = $.trim(bindings[0]),
				name = $.trim(bindings[1]),
				value = '',
				condition;

			$this.addClass('ctHidden');

			if (type === 'text') {
				$this.html($(':input[name="' + name + '"]', $ctx).val());

			} else if (type === 'radio') {
				$this.html($(':input[name="' + name + '"]:checked', $ctx).val());

			} else if (type === 'conditional') {
				value = $(':input[name="' + name + '"]', $ctx).val();
				condition = $.trim(bindings[2]);

				if (condition === value) {
					$this.show();
				} else {
					$this.hide();
				}
			}
		});

		//hide empty elements
		mod.$ctx.find('dd:empty').each(function () {
			$(this).prev('dt').addClass('hidden');
		});
	};

	/**
	 * This function is a listener for all wizard-step-modules that want to delete other steps ahead of them because of changed data (occures if a user navigates back through wizard-steps)
	 *
	 * @method onClearWizardSteps
	 * @param {object} data containing "stepContainer" which can be a wizard-step or any module within
	 * @return void
	 */
	this.onClearWizardSteps = function (data) {
		var stepContainer = data.stepContainer.is('.multipage-wizard-step') ? data.stepContainer : data.stepContainer.closest('.multipage-wizard-step');

		stepContainer.nextAll().remove();
	};

	/**
	 * After displaying a form wizard step, calculates the width of custom dropdowns, to display them correctly
	 *
	 * @method recalculateDropdownWidths
	 * @param $step
	 */
	this.recalculateDropdownWidths = function ($step) {
		$step.find('.newList').each(function () {
			var list = $(this);
			list.css('min-width', (list.closest('.newListSelected').outerWidth() - (list.outerWidth() - list.width())) + 'px');
		});
	};

	/**
	 * Add top padding to each step of the form if back button has sub label text
	 * @return void
	 */
	this.addFormStepTopPadding = function () {
		var $currentFormStep = this.currentFormStep();

		if ($.trim($('.scs-navigation-button-sub-label:visible', $currentFormStep).html()) && $currentFormStep.css('padding-top') !== '22px') {
			$currentFormStep.css('padding-top', '22px');
		}
	};

	this.currentFormStep = function () {
		return $('form > div:visible', this.$ctx);
	};

	// Advances to the next form step if possible (but validates first)
	this.advanceStep = function advanceStep() {
		var $currentFormStep = this.currentFormStep();
		var $actionButton = $currentFormStep.find('.forward .multipage-forward-button');
		if ($actionButton.length > 0) {
			$actionButton[0].click();
			return true;
		}
	};

	// Advances to the next form step if possible (but validates first)
	this.stepAction = function stepAction() {
		var $currentFormStep = this.currentFormStep();
		var $actionButton = $currentFormStep.find('.action .multipage-action-button');
		if ($actionButton.length > 0) {
			$actionButton[0].click();
			return true;
		}
	};

	this.processPayment = function (tvProductId) {
		var mod = this;

		var ajaxUrl = $('input[name=":formstart"]').val() + '.payment.json',
			firstName = $('input[name="lead_contact_person_first_name"]').val(),
			lastName = $('input[name="lead_contact_person_last_name"]').val(),
			email = $('input[name="lead_contact_email_address"]').val(),
			etage = false,
			postData;

		if ($('input[name="lead_etagenlieferung"]:checked').length) {
			postData = [tvProductId, 'etage'];
			etage = true;
		}
		else {
			postData = tvProductId;
			etage = false;
		}

		return $.post(ajaxUrl, {productId: postData}, function (data) {
			if (data && data.success) {
				mod.$ctx.find('#user_ref').val(data.refno);

				$.getScript(data.datatransJavaScriptUrl).done(function () {
					var params = {
						merchantId: data.merchantId,
						amount: data.amount,
						currency: data.currency,
						refno: data.refno,
						sign: data.sign,
						successUrl: data.successUrl,
						cancelUrl: data.cancelUrl,
						errorUrl: data.errorUrl,
						uppWebResponseMethod: 'GET',
						uppStartTarget: '_top',
						fName: firstName,
						lName: lastName,
						email: email,
						pID: tvProductId,
						etage: etage
					};
					window.Datatrans.startPayment({params: params});
				}).fail(function () {
					this.showAjaxError();
				});
			} else {
				this.showAjaxError();
			}
		});


	};
};

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/forms/clientlibs/shared/js/modules/Tc.Module.ScForm.MultipageWizard.js
// module id = 282
// module chunks = 0